"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONTEXT_MENU_GRADIENT = exports.FOCUS_B = exports.FOCUS = exports.SEAFOAM_SLAP = exports.SUNDAY_FUNDAY = exports.LIPSTICK_RED = exports.DARK_PURPLE = exports.DARK_BLURPLE = exports.PURPLE = exports.LOVELY_LAVENDER = exports.ROW_HOVER = exports.COTTON_BALL = exports.BLACK_SOUL = exports.DARK_GREY = exports.GREY_8 = exports.GREY_7 = exports.GREY_6 = exports.GREY_5 = exports.GREY_4 = exports.GREY_3 = exports.GREY_2 = exports.GREY_1 = exports.WHITE = void 0;
// Grey scale
var WHITE = '#FFFFFF';
exports.WHITE = WHITE;
var GREY_1 = '#FAFBFD';
exports.GREY_1 = GREY_1;
var GREY_2 = '#F5F5F5';
exports.GREY_2 = GREY_2;
var GREY_3 = '#E6E6E6';
exports.GREY_3 = GREY_3;
var GREY_4 = '#D2D2D2';
exports.GREY_4 = GREY_4;
var GREY_5 = '#999999';
exports.GREY_5 = GREY_5;
var GREY_6 = '#888888';
exports.GREY_6 = GREY_6;
var GREY_7 = '#717171';
exports.GREY_7 = GREY_7;
var GREY_8 = '#4D4D4D';
exports.GREY_8 = GREY_8;
var DARK_GREY = '#4C5165';
exports.DARK_GREY = DARK_GREY;
var BLACK_SOUL = '#2D2D2D'; // Base colors

exports.BLACK_SOUL = BLACK_SOUL;
var COTTON_BALL = '#F3F4F9';
exports.COTTON_BALL = COTTON_BALL;
var ROW_HOVER = '#E8ECF6';
exports.ROW_HOVER = ROW_HOVER;
var LOVELY_LAVENDER = '#A1AEE5';
exports.LOVELY_LAVENDER = LOVELY_LAVENDER;
var PURPLE = '#42368E';
exports.PURPLE = PURPLE;
var DARK_BLURPLE = '#190050';
exports.DARK_BLURPLE = DARK_BLURPLE;
var DARK_PURPLE = '#9586B7';
exports.DARK_PURPLE = DARK_PURPLE;
var LIPSTICK_RED = '#E01B25';
exports.LIPSTICK_RED = LIPSTICK_RED;
var SUNDAY_FUNDAY = '#FEC82A';
exports.SUNDAY_FUNDAY = SUNDAY_FUNDAY;
var SEAFOAM_SLAP = '#28CEA8';
exports.SEAFOAM_SLAP = SEAFOAM_SLAP;
var FOCUS = '#7B61FF'; // Use when the background-color is a dark purple (#42368E or #190050). Does not pass text color contrast requirements.

exports.FOCUS = FOCUS;
var FOCUS_B = '#5339D7'; // Main focus ring color. Passes text color contrast requirements.

exports.FOCUS_B = FOCUS_B;
var CONTEXT_MENU_GRADIENT = "\n  linear-gradient(154.54deg, rgba(197, 14, 14, 0.24) -13.56%, rgba(255, 255, 255, 0) 45.07%),\n  radial-gradient(215.14% 265.14% at 75.14% -151.59%, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0) 100%),\n  linear-gradient(12.71deg, rgba(255, 255, 255, 0) 24.53%, rgba(104, 83, 150, 0.2) 75.6%),\n  linear-gradient(0deg, #200066, #200066),\n  #190050\n";
exports.CONTEXT_MENU_GRADIENT = CONTEXT_MENU_GRADIENT;